import { Hero } from "@/components/landing/Hero";
import { Chapters } from "@/components/landing/Chapters";

export const Home = ({ ready = true }) => (
  <main>
    <Hero ready={ready} />
    <Chapters />
  </main>
);
